import { Reducer } from 'redux';
import { PreCasInterviewState, PreCasInterviewTypes } from './types';
import { StudentActionTypes } from '../types';

const initialState: PreCasInterviewState = {
  whyUk: '',
  whyUkOther: '',
  selectedCourseReasons: [],
  selectedCourseReasonsOther: '',
  selectedUniReasons: [],
  selectedUniReasonsOther: '',
  uniChoiceReason1: '',
  uniChoiceReason2: '',
  uniChoiceReason3: '',
  campus: '',
  considerOtherUni: true,
  otherUni1: '',
  otherUni2: '',
  selectedResearchMethods: [],
  selectedResearchMethodsOther: '',
  whyNotOtherUni: '',
  considerOtherCourses: undefined,
  considerOtherCourse: '',
  whyNotConsiderOtherCourse: '',
  courseAlignFutureCareer: undefined,
  courseAlignFutureCareerOther: '',
  workWhileStudy: undefined,
  maxWorkHoursPerWeek: '',
  whyWorkWhileStudy: '',
  whyWorkWhileStudyOther: '',
  affordCourseAndLivingWithoutWorking: undefined,
  affordCourseAndLivingWithoutWorkingNo: '',
  completeDegreeWorkCountry: '',
  expectedSalary: 0,
  furtherStudyInUk: undefined,
  furtherStudyCareerPlans: '',
  liveWhileStudying: '',
  liveWhileStudyingOther: '',
  expectedWeeklyRent: 0,
  commutePlan: '',
  expectedLivingExpenses: 0,
  awareOfUKVIInterview: undefined,
  isSectionStarted: false,
  isSectionComplete: false
};

const reducer: Reducer<PreCasInterviewState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...state,
        ...action.payload.student.preCasInterview
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        ...action.payload.preCasInterview
      };
    case PreCasInterviewTypes.UPDATE_PCI_FIELD:
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value
      };
    default:
      return state;
  }
};

export { reducer as preCasInterviewReducer };
